import { PlatformCallbackPage } from './PlatformCallbackPage'

export function TwitterCallbackPage() {
  return <PlatformCallbackPage platform="twitter" />
}
